import { render, staticRenderFns } from "./IdentifyCode.vue?vue&type=template&id=1780b436&scoped=true"
import script from "./IdentifyCode.vue?vue&type=script&lang=js"
export * from "./IdentifyCode.vue?vue&type=script&lang=js"
import style0 from "./IdentifyCode.vue?vue&type=style&index=0&id=1780b436&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1780b436",
  null
  
)

export default component.exports